// extracted by mini-css-extract-plugin
export default {"container":"OneFel_container__zSM-9","labeldatafactura":"OneFel_labeldatafactura__7aEGK","btnfel":"OneFel_btnfel__UlTLu"};